<template>
    <span class="app-track-referrals-menu">
        <common-button
            v-clickaway="closeDropdown"
            :label="$t('layouts.app.topnav.track_referrals')"
            type="track-referral"
            size="medium"
            icon="referral-track"
            :isClicked="isDropdownOpen"
            @click="toggleDropdown"
        ></common-button>

        <common-dropdown
            class="app-track-referrals-menu--dropdown"
            :isOpen="isDropdownOpen"
            :hasArrow="false"
            bgColor="gray"
            arrowPositionY="top"
            arrowPositionX="left"
        >
            <common-dropdown-items :menuItems="menuItems" @item-clicked="itemClicked"></common-dropdown-items>
        </common-dropdown>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                isDropdownOpen: false,
            }
        },

        computed: {
            menuItems() {
                return [
                    {
                        name: this.$t('layouts.app.topnav.received_referrals'),
                        payload: { route: 'referrals.received' },
                        hidden: this.$auth.isUserPracticeOther(),
                    },
                    {
                        name: this.$t('layouts.app.topnav.made_referrals'),
                        payload: { route: 'referrals.made' },
                        hidden: this.$auth.isUserTemporaryPhysician(),
                    },
                ]
            },
        },

        methods: {
            toggleDropdown() {
                this.isDropdownOpen = !this.isDropdownOpen
            },
            closeDropdown() {
                this.isDropdownOpen = false
            },

            itemClicked(payload) {
                this.$router.push({ name: payload.route })
            },
        },

        watch: {
            $route() {
                this.isDropdownOpen = false
            },
        },
    }
</script>
